import React from 'react';
import { PLAYER_VOTED_EVENT } from '@mentimeter/quiz-types';
import { useSubscribe } from './use-subscribe';

export const useSubscribeRespondents = () => {
  const [respondents, setRespondents] = React.useState<Array<string>>([]);
  useSubscribe({
    event: PLAYER_VOTED_EVENT,
    callback: React.useCallback(({ identifier }: { identifier: string }) => {
      setRespondents((prev) => {
        if (prev.includes(identifier)) return prev;
        return [...prev, identifier];
      });
    }, []),
  });

  const resetRespondents = React.useCallback(() => void setRespondents([]), []);

  return {
    respondents,
    resetRespondents,
  };
};
